import Image from 'next/image'
import { useState } from 'react'

function Author({ author }) {
  const [linkedin, setLinkdin] = useState(false)
  return (
    <section className="resumewriter">
      <Image
        className="profile"
        width={200}
        height={200}
        src={author.profileImg}
        alt="article cover"
      />
      <div className="body">
        <span className="name">
          About the Author: {author.firstname} {author.lastname}{' '}
          {author.linkedin && (
            <a href={author.linkedin} target="_blank" rel="noreferrer">
              <Image
                width={15}
                height={15}
                onMouseOver={() => setLinkdin(true)}
                onMouseLeave={() => setLinkdin(false)}
                className={linkedin ? 'dark' : 'light'}
                src={linkedin ? '/images/inw.png' : '/images/inb.png'}
                alt="Linkedin"
              />
            </a>
          )}
        </span>
        <span
          className="description"
          dangerouslySetInnerHTML={{ __html: author.description }}
        />
      </div>
    </section>
  )
}
export default Author
